module.exports = __webpack_public_path__ + "static/img/g457.abfb80f1.png";